import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PackagesPage from "@/pages/PackagesPage";
import PackageDetailPage from "@/pages/PackageDetailPage";
import BookPage from "@/pages/BookPage";
import BookingPendingPage from "@/pages/BookingPendingPage";
import WeddingsPage from "@/pages/WeddingsPage";
import EasyArrivalPickerPage from "@/pages/EasyArrivalPickerPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/packages" element={<PackagesPage />} />
                        <Route path="/packages/:packageId" element={<PackageDetailPage />} />
                        <Route path="/book" element={<BookPage />} />
                        <Route path="/book/:packageId" element={<BookPage />} />
                        <Route path="/weddings" element={<WeddingsPage />} />
                        <Route path="/easy-arrival/choose-meal" element={<EasyArrivalPickerPage />} />
                        <Route path="/booking/pending/:bookingId" element={<BookingPendingPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                    </Route>
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route path="/admin" element={<AdminDashboardPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#FFFFFF",
                        border: "1px solid #8DA39955",
                        color: "#1A231C",
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
